import { createStore } from 'vuex'
import Logger from '../helpers/logger';
import CheckoutDataService from "@/services/useCheckout";
import mapProducts from './mapProducts';
import mapDiscount from './mapDiscount';

export default createStore({
  state: {
    cartId: '',
    webUrl: '',
    discountCode: '',
    discountAmount: 0,
    discountPercentage: 0,
    products: [],
    referrer: ''
  },
  getters: {
    products: state => {
      return state.products;
    },
    getProductById: state => variantId => {
      return state.products.find(product => product.id === variantId);
    },
    getCartQuantity: state => {
      return state.products.map(item => item.quantity).reduce((a,b) => a+b, 0);
    },
    webUrl: state => {
      return state.webUrl;
    },
    cartId: state => {
      return state.cartId;
    },
    discountCode: state => {
      return state.discountCode;
    },
    discountAmount: state => {
      return state.discountAmount;
    },
    discountPercentage: state => {
      return state.discountPercentage;
    }
  },
  mutations: {
    initializeStore(state){
      if(localStorage.getItem('HBGCartStore')){
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem('HBGCartStore')))
        )
      }
    },
    SET_PRODUCTS (state, products){
      Logger.log("SET PRODUCTS");
      Logger.log(products);
      state.products = products;
    },
    OPTIMISTIC_SET_PRODUCT_QUANTITY (state, product){
      Logger.log("OPTIMISTIC SET PRODUCT QUANTITY");
      Logger.log(product);
      const products = [...state.products];
      products.find(p => p.id === product.variantId).quantity = product.quantity;
      state.products = products;
    },
    OPTIMISTIC_DELETE_PRODUCT (state, product) {
      Logger.log("OPTIMISTIC DELETE PRODUCT");
      Logger.log(product);
      state.products = state.products.filter(p => p.variantId !== product.variantId);
    },
    SET_CART (state, cart){
      Logger.log("SET CART");
      Logger.log(cart);
      state.cartId = cart.id;
      state.webUrl = cart.webUrl;
    },
    SET_DISCOUNT (state, discount){
      Logger.log("SET DISCOUNT");
      Logger.log(discount);
      Logger.log(discount[0].code ?? '');
      state.discountCode = discount[0].code ?? '';
      state.discountAmount = discount[0].amount ?? 0;
      state.discountPercentage = discount[0].percentage ?? 0;
    },
    SET_REFERRER (state, referrer){
      state.referrer = referrer;
    }
  },
  actions: {
    async initCart ({ commit }, cart){
      try{
        Logger.log("INIT CART")
        Logger.log(cart);
        let cartId = await CheckoutDataService.createCart();
        Logger.log("CART CREATED");
        Logger.log(cartId);
        commit('SET_CART', cartId);
      }
      catch (error){
        commit('SET_CART', '');
        Logger.log(error);
      }
    },
    async loadCart ({ commit }, cart){
      try{
        Logger.log("LOAD CART");
        Logger.log(cart);
        let cartId = await CheckoutDataService.loadCart(cart.id);
        Logger.log("CART LOADED");
        Logger.log(cartId);
        commit('SET_CART', cartId);
        // Logger.log("DISCOUNT TEST");
        // Logger.log(mapDiscount(cartId.discounts));
        let discountStatus = mapDiscount(cartId.discounts);
        if (discountStatus.length == 0) {
          discountStatus = [{code: '', amount: 0, percentage: 0}];
        }
        commit('SET_DISCOUNT', discountStatus);
      }
      catch (error){
        Logger.log("ERROR");
        // commit('SET_CART', '');
        // commit('SET_DISCOUNT', [{code: '', amount: 0, percentage: 0}]);
        Logger.log(error);
      }
    },
    async getProducts ({ commit }, cart){
      try{
          Logger.log("GET PRODUCTS")
          Logger.log(cart);
        if(cart.id !== '') {
          let currentCart = await CheckoutDataService.getCart();
          Logger.log("CURRENT CART");
          Logger.log(currentCart);
          Logger.log(mapProducts(currentCart));
          // let sampleCart = [{id: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MTgxNzA1ODExNTc0NA==', title: 'Delicious Foods', primaryAuthor: 'James Hannaham', format: 'Trade Paperback', quantity: 1, price: 16.99, coverURL: 'https://www.hachettebookgroup.com/wp-content/uploads/2017/06/9780316284936.jpg?fit=450%2C675'},{id: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MTgxNzA2MjM3NTU4NA==', title: 'How the Word Is Passed', primaryAuthor: 'Clint Smith', format: 'Hardcover', quantity: 1, price: 29, coverURL: 'https://www.hachettebookgroup.com/wp-content/uploads/2022/01/9780316492935.jpg?fit=435%2C675'}];
          commit('SET_PRODUCTS', mapProducts(currentCart));
        } else {
          commit('SET_PRODUCTS', []);
        }
      }
      catch (error){
        commit('SET_PRODUCTS', []);
        Logger.log(error);
      }
    },
    async addToCart({ commit }, product){
      try{
        Logger.log("ADD TO CART")
        Logger.log(product);
        let addedItem = await CheckoutDataService.addItemToCart(product.variantId, product.quantity);
        if(0 == addedItem.length){
          localStorage.removeItem('HBGCartStore');
          let cartId = await CheckoutDataService.createCart();
          addedItem = await CheckoutDataService.addItemToCart(product.variantId, product.quantity);
          commit('SET_CART', cartId);
        }
        Logger.log("ITEM ADDED TO CART");
        Logger.log(addedItem);
        Logger.log(mapProducts(addedItem));
        commit('SET_PRODUCTS', mapProducts(addedItem));
      }
      catch (error){
        Logger.log(error);
      }
    },
    async removeFromCart({ commit }, cart){
      try{
        Logger.log("REMOVE FROM CART")
        Logger.log(cart);
        commit('OPTIMISTIC_DELETE_PRODUCT', cart);
        let removedItem = await CheckoutDataService.removeItemFromCart(cart.variantId);
        Logger.log("DELETED ITEM");
        Logger.log(removedItem);
        commit('SET_PRODUCTS', mapProducts(removedItem));
      }
      catch (error){
        Logger.log(error);
      }
    },
    async changeItemQuantity ({ commit }, cart){
      try{
        Logger.log("CHANGE ITEM QUANTITY");
        Logger.log(cart);
        commit('OPTIMISTIC_SET_PRODUCT_QUANTITY', cart);
        let updatedItem = await CheckoutDataService.updateItemInCart(cart.variantId, cart.quantity);
        Logger.log("UPDATED ITEM");
        Logger.log(updatedItem);
        commit('SET_PRODUCTS', mapProducts(updatedItem));
      }
      catch (error){
        Logger.log(error);
      }
    },
    async addDiscountCode ({ commit }, cart){
      try{
        Logger.log("ADD DISCOUNT CODE");
        Logger.log(cart);
        let discount = await CheckoutDataService.addDiscount(cart.discountCode);
        Logger.log("DISCOUNT");
        Logger.log(discount);
        if (false !== discount){
          commit('SET_DISCOUNT', mapDiscount(discount));
        }
        else {
          // future error display here
          commit('SET_DISCOUNT', [{code: '', amount: 0}]);
        }
      }
      catch (error){
        Logger.log(error);
      }
    },
    async removeDiscountCode ({ commit }, cart){
      try{
        Logger.log("REMOVE DISCOUNT CODE");
        Logger.log(cart);
        let discount = await CheckoutDataService.removeDiscount();
        Logger.log("DISCOUNT");
        Logger.log(discount);
        commit('SET_DISCOUNT', [{code: '', amount: 0}]);
      }
      catch (error){
        Logger.log(error);
      }
    },
    async setReferrer ({ commit }, location){
      try{
        Logger.log("SET REFERRER");
        Logger.log(location);
        await CheckoutDataService.setReferrer(location.referrer);
        commit('SET_REFERRER', location.referrer);
      }
      catch (error){
        Logger.log(error);
      }
    }
  },
  modules: {
  }
})
